export const nav = {
    permissao: 'hdocs.variaveis:ver',
    section: 'Configuracao',
    title: 'Variaveis',
    icon: 'data_object',
    route: '/variaveis',
    sequence: 12, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/variaveis',
        name: 'variaveis',
        component: () => import('./pages/VariaveisPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.variaveis:ver' },
    },
];
